import {} from 'svelte/internal';
import Tooltip from './Tooltip.svelte';
export var Direction;
(function (Direction) {
    Direction["TOP"] = "top";
    Direction["RIGHT"] = "right";
    Direction["LEFT"] = "left";
    Direction["BOTTOM"] = "bottom";
})(Direction || (Direction = {}));
export function tooltip(element, options) {
    var _a, _b;
    let tooltipComponent;
    const TooltipConstructor = (_a = options.Component) !== null && _a !== void 0 ? _a : Tooltip;
    let tooltipData = (_b = options.data) !== null && _b !== void 0 ? _b : null;
    let mousePressed = false;
    let tooltipShown = false;
    function mouseEnter(_event) {
        var _a, _b, _c, _d;
        if (tooltipData === null || mousePressed)
            return;
        let rect;
        let top;
        let left;
        if (options.anchor === 'parentElement') {
            rect = (_b = (_a = element.parentElement) === null || _a === void 0 ? void 0 : _a.getBoundingClientRect()) !== null && _b !== void 0 ? _b : new DOMRect(0, 0, 0, 0);
        }
        else if (options.anchor === 'offsetParent') {
            rect = (_d = (_c = element.offsetParent) === null || _c === void 0 ? void 0 : _c.getBoundingClientRect()) !== null && _d !== void 0 ? _d : new DOMRect(0, 0, 0, 0);
        }
        else {
            rect = element.getBoundingClientRect();
        }
        if (options.direction === Direction.RIGHT) {
            top = rect.top;
            left = rect.right + 8;
        }
        else {
            top = rect.bottom + 10;
            left = rect.left;
        }
        tooltipComponent = new TooltipConstructor({
            props: {
                data: tooltipData,
                top,
                left,
            },
            target: document.body,
        });
        tooltipShown = true;
    }
    function mouseLeave() {
        if (tooltipData === null || mousePressed)
            return;
        tooltipComponent.$destroy();
    }
    function mouseMove(_event) {
        if (tooltipData === null || !mousePressed || !tooltipShown)
            return;
        tooltipComponent.$destroy();
        tooltipShown = false;
        /*  tooltipComponent.$set({
          x: event.pageX,
          y: event.pageY,
        }) */
    }
    function mouseDown(_event) {
        mousePressed = true;
    }
    function mouseUp(event) {
        mousePressed = false;
        if (!tooltipShown)
            mouseEnter(event);
    }
    element.addEventListener('mouseenter', mouseEnter);
    element.addEventListener('mousemove', mouseMove);
    element.addEventListener('mouseleave', mouseLeave);
    element.addEventListener('mousedown', mouseDown);
    element.addEventListener('mouseup', mouseUp);
    return {
        // is called whenever the parameter (options) changes
        // argument is the new parameter
        update({ data }) {
            // update the local variable from here, else the tooltip would reset
            // to the starting value if it's destroyed and created again
            tooltipData = data;
            // programmatically sets props on an instance. component.$set({ x: 1 })
            // is equivalent to x = 1 inside the component's <script> block.
            if (tooltipComponent !== undefined)
                tooltipComponent.$set({ data });
        },
        destroy() {
            if (tooltipComponent !== undefined)
                tooltipComponent.$destroy();
            element.removeEventListener('mouseenter', mouseEnter);
            element.removeEventListener('mousemove', mouseMove);
            element.removeEventListener('mouseleave', mouseLeave);
            element.removeEventListener('mousedown', mouseDown);
            element.removeEventListener('mouseup', mouseUp);
        },
    };
}
